import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form, ModalItem, FormItem, ButtonItem,
  InputItem, InputNumberItem, DatePickerItem, ErrorItem, TablaEditor
} from "../../../../Components/Items";

// Columnas fijas — el usuario no puede agregarlas ni eliminarlas
const COLUMNAS_FIJAS = [
  { nombre: "Antigüedad", tipo: "numero" },
  { nombre: "Días Vacaciones", tipo: "numero" },
  { nombre: "Porc. Prima Vacacional", tipo: "numero" },
  { nombre: "Días Aguinaldo", tipo: "numero" },
  { nombre: "Factor Integración", tipo: "numero" },
  { nombre: "Días Antigüedad", tipo: "numero" },
];

class AgregarTipoPrestacion extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
    // Columnas siempre fijas, filas editables
    filas: [],
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible, filas: [] });
    }
  }

  onFinishFailed(e) { ErrorItem(e); }

  // El editor solo puede cambiar filas — ignoramos cambios de columnas
  onEditorChange({ filas }) {
    this.setState({ filas });
  }

  onFinish(values) {
    if (!values?.nombre) return message.info("Proporcione el nombre del tipo de prestación");

    const filas = this.state.filas.map(({ key, ...f }) => f);

    this.setState({ loading: true });
    axios
      .post(
        "tiposPrestaciones/agregarTipoPrestacion",
        { ...values, filas, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Tipo de prestación agregado exitosamente");
          this.cerrarModal();
        } else if (res.data.success === 1) {
          message.error("No se pudo agregar el tipo de prestación");
        } else {
          message.error("Sucedió un error y no se pudo agregar el tipo de prestación");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.setState({ visible: false, filas: [] });
    this.props.cerrarAgregarTipoPrestacion();
    if (this.formRef.current) this.formRef.current.resetFields();
  };

  render() {
    return (
      <ModalItem
        title="Agregar Tipo de Prestación"
        visible={this.state.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={900}
      >
        <Form
          ref={this.formRef}
          name="modalAgregarTipoPrestacion"
          layout
          bottom={
            <ButtonItem type="primary" htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}>
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem name="nombre" label="Nombre" required margin>
            <InputItem placeholder="Ej: Prestaciones Mínimas de Ley 2024" />
          </FormItem>

          <FormItem name="nombreFormula" label="Nombre Fórmula" margin
            tooltip="Sin espacios ni caracteres especiales. Ej: prestMinLey2024">
            <InputItem
              placeholder="Ej: prestMinLey2024"
              style={{ fontFamily: "monospace" }}
              onChange={(e) => {
                const limpio = e.target.value.replace(/[^a-zA-Z0-9_]/g, "");
                this.formRef.current.setFieldsValue({ nombreFormula: limpio });
              }}
            />
          </FormItem>

          <FormItem name="descripcion" label="Descripción" margin>
            <InputItem placeholder="Descripción opcional" />
          </FormItem>

          <FormItem name="ejercicio" label="Ejercicio" margin>
            <InputNumberItem placeholder="Ej. 2024" min={2000} max={2100} />
          </FormItem>

          <FormItem name="fechaInicioVigencia" label="Inicio de Vigencia" margin>
            <DatePickerItem placeholder="Informativo" style={{ width: "100%" }} />
          </FormItem>

          <FormItem name="fechaFinVigencia" label="Fin de Vigencia" margin>
            <DatePickerItem placeholder="Informativo" style={{ width: "100%" }} />
          </FormItem>
        </Form>

        <div style={{ marginTop: 16 }}>
          {/* columnasFijas=true oculta el botón "Agregar columna" y deshabilita renombrar/eliminar columnas */}
          <TablaEditor
            columnas={COLUMNAS_FIJAS}
            filas={this.state.filas}
            onChange={this.onEditorChange.bind(this)}
            columnasFijas
          />
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AgregarTipoPrestacion);